"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Document;

var _Document = require("@adobe/react-spectrum-workflow/dist/Document");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Document(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Document.A4uDocument, null));
}